// CODATA 2018, the value the registry's masses were derived with from JPL GMs.
// No runtime imports: tools/preview reads this file under Node, types stripped.
export const GRAVITATIONAL_CONSTANT_M3_KG_S2 = 6.6743e-11;

/** Same constant in the km-kg-s units orbital elements use. */
export const GRAVITATIONAL_CONSTANT_KM3_KG_S2 = GRAVITATIONAL_CONSTANT_M3_KG_S2 / 1e9;
